import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import image1 from "./images/white background.png";
import image2 from "./images/white background.png";
import ResigterPage from "./component/Resigter/ResigterPage";
import HomeScreen from "./component/Home/HomeScreen";
import Buliding from "./component/Buliding/Buliding";
import FaqPage from "./component/Faq/FaqPage";
import ProfilePage from "./component/Profile/profilePage";
import Loginpage from "./component/Login/Loginpage";
import ForgotPassword from "./component/forgot-password/ForgotPassword";
import TermsAndConditions from "./component/social/termsandcondition";
import PrivacyPolicy from "./component/social/privacypolicy";
import WalletTransactions from "./component/Wallet/WalletTransactions";
import Topup from "./component/Top-up/topup";
import BlogSection from "./component/Blog/BlogSection";
import BlogDetail from "./component/Blog/BlogDetail";
import ProtectedRoute from "./component/ProtectedRoute";

function App() {
  return (
    <div>
      {/* Background Images */}
      <img src={image1} className="bg" alt="Background" />
      <img src={image2} className="bg2" alt="Background" />

      <Routes basename={process.env.REACT_APP_HOMEPAGE}>
        <Route path="/register" element={<ResigterPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route
          path="/topup"
          element={
            <ProtectedRoute>
              <Topup />
            </ProtectedRoute>
          }
        />
        <Route path="/news" element={<BlogSection />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route
          path="/withdraw"
          element={
            <ProtectedRoute>
              <WalletTransactions />
            </ProtectedRoute>
          }
        />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/" element={<Loginpage />} />
        <Route path="/home" element={<HomeScreen />} />
        <Route
          path="/myteam"
          element={
            <ProtectedRoute>
              <Buliding />
            </ProtectedRoute>
          }
        />
        <Route path="/faq" element={<FaqPage />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
